"use strict";

/**
 * Returns the first element of the given array.
 *
 * @param {Array} arr
 * @return {*}
 * @example
 *
 *      head(['fi', 'fo', 'fum']); //=> 'fi'
 *      head([]); //=> undefined
 */
module.exports = function (arr) {
  return arr && arr[0];
};